import { render, staticRenderFns } from "./CombinationsWarning.vue?vue&type=template&id=5624ca3c&scoped=true"
import script from "./CombinationsWarning.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinationsWarning.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CombinationsWarning.vue?vue&type=style&index=0&id=5624ca3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5624ca3c",
  null
  
)

export default component.exports